export const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

export const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
};

export const categoryLabels = {
  abundance: "Abundance",
  true_essence: "True Essence",
  liberation: "Liberation",
  peace: "Peace",
  radiance: "Radiance",
  strength: "Strength",
  well_being: "Well-Being",
  alignment: "Alignment"
};
